import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import type { AreaItem } from "../../viewer-components/services/internal-services/geo.service";
import type { DetectionApiResponse } from "./detection/detection.communicator.service";
export type { AreaItem };

export interface CustomElementsLaunchRequest {
  /** One or more geometries — 1 when drawn, N when from file/search. */
  areas: AreaItem[];
  /** User-facing label shown in the area summary card. */
  label?: string;
  /** Pre-built WKT for map area visualisation. When provided the toolbar uses
   *  it directly and skips reconstructing the MULTIPOLYGON from `areas`. */
  visualWkt?: string;
  /** Pre-computed detections (agent handoff, viewer-handoff plan F3). When present the
   *  toolbar skips the configure/run flow and lands directly in the results stage. */
  results?: DetectionApiResponse;
}

/**
 * Cross-feature bridge used to open the Custom Elements detection panel
 * pre-configured with a geographic area built from another feature
 * (e.g. embeddings search results).
 *
 * Consumers (search-summary-panel, etc.) call `launch()`.
 * The CustomElementsToolbarComponent subscribes to `launchRequest$`,
 * activates its toolbar, applies the area, and jumps to the configure stage.
 */
@Injectable({ providedIn: "root" })
export class CustomElementsLauncherService {
  private readonly launchSubject = new Subject<CustomElementsLaunchRequest>();

  readonly launchRequest$: Observable<CustomElementsLaunchRequest> = this.launchSubject.asObservable();

  launch(request: CustomElementsLaunchRequest): void {
    this.launchSubject.next(request);
  }
}